<script setup>
    import { ref, computed } from 'vue'
    import SingleEdit from '@/js/components/Common/SingleEdit.vue'

    const props = defineProps({
        angebotsFrequenz: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() => (props.language === 'englisch' ? 'Frequency | Angebotsfrequenz' : 'Angebotsfrequenz'))

    const emit = defineEmits(['angebotsFrequenzSaved'])
    const angebotsFrequenzOptions = computed(() => {
        const isEnglish = props.language === 'englisch'
        return [
            { title: isEnglish ? 'Every semester' : 'Jedes Semester', value: 'Jedes Semester' },
            { title: isEnglish ? 'Every 2 semesters' : 'Alle 2 Semester', value: 'Alle 2 Semester' },
            { title: isEnglish ? 'Winter semester only' : 'nur WiSe', value: 'nur WiSe' },
            { title: isEnglish ? 'Summer semester only' : 'nur SoSe', value: 'nur SoSe' },
            { title: isEnglish ? 'Irregular' : 'unregelmäßig', value: 'unregelmäßig' }
        ]
    })

    let editAngebotsFrequenz = ref('')

    function handleEditStart() {
        editAngebotsFrequenz.value = props.angebotsFrequenz
    }

    function handleEditAbort() {
        editAngebotsFrequenz.value = ''
    }

    const saveAngebotsFrequenz = () => {
        emit('angebotsFrequenzSaved', editAngebotsFrequenz.value)
    }
</script>

<template>
    <single-edit
        :entry="angebotsFrequenz"
        edit-key="angebotsfrequenz"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveAngebotsFrequenz"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-select-field-single
                v-model="editAngebotsFrequenz"
                :items="angebotsFrequenzOptions"
                class="w-100 h-100"
                tile
                density="default"
            />
        </template>
    </single-edit>
</template>

<style scoped lang="scss"></style>
